import { Model } from '@/models/Model';
import store from '@/store';
export class Message extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Message';
        this.$endpoint = '/chat/messages';
        this.$fillable = ['key', 'room', 'text', 'file'];
    }
    createBulk(attributes) {
        const url = `${this.$endpoint}/bulk`;
        attributes = this.getPayload(attributes);
        return this.request('post', url, attributes);
    }
    setUserAttribute(user) {
        const authUser = store.state.Auth;
        if (authUser !== null) {
            this.isAuthor = authUser.id === user.id;
        }
        else {
            this.isAuthor = false;
        }
        return user;
    }
}
